module.exports = __webpack_public_path__ + "img/diaohua2.5fbd21c8.jpg";